/**
 * Plantilla de endpoint para los errores de Métricas de Actividad: método + ruta SIN query y con los ids
 * reemplazados, ej. `GET /v2/psychologists/:id/sessions`.
 *
 * Privacidad: un segmento de la ruta solo se conserva si es una palabra en minúsculas con guiones o una versión
 * (`v2`). Todo lo demás (ids, números, uuid, emails, nombres con mayúscula) pasa a `:id`, y la query nunca viaja.
 * El backend valida con la misma regla (`ENDPOINT_KEY_PATTERN` de `activity.schema.ts`) y rechaza lo que no cumple.
 */
export const ENDPOINT_KEY_MAX_LENGTH = 80;
const SEGMENT = /^(v\d+|[a-z][a-z-]{1,30})$/;
const METHODS = new Set(["GET", "POST", "PUT", "PATCH", "DELETE"]);
/** Misma regla que valida el backend: se chequea antes de enviar para no mandar nada que vaya a rechazar. */
export const ENDPOINT_KEY_PATTERN = /^(GET|POST|PUT|PATCH|DELETE) (\/(:id|v\d+|[a-z][a-z-]{1,30}))+$/;

/** `undefined` si no se puede armar una plantilla segura (método raro, sin ruta, demasiado larga). */
export function buildEndpointKey(method: string | undefined, url: string): string | undefined {
  try {
    const verb = (method ?? "GET").toUpperCase();
    if (!METHODS.has(verb)) return undefined;
    // Solo el pathname: se descartan origen, query y hash antes de mirar nada.
    const path = url.replace(/^[a-z][a-z0-9+.-]*:\/\/[^/]*/i, "").split(/[?#]/)[0];
    const segments = path.split("/").filter(Boolean);
    if (segments.length === 0) return undefined;
    const key = `${verb} /${segments.map((s) => (SEGMENT.test(s) ? s : ":id")).join("/")}`;
    if (key.length > ENDPOINT_KEY_MAX_LENGTH || !ENDPOINT_KEY_PATTERN.test(key)) return undefined;
    return key;
  } catch {
    return undefined;
  }
}
